export enum StopType {
    School = 0,
    Stop = 1,
    Address = 2
}
